import { MIN_CHARS } from "./constants";

export function validateEmail(value, required) {
  const trimmedValue = (value || '').trim();
  
  if (!trimmedValue) {
    return {
      valid: !required,
      errorKey: required ? "EnterAValidEmail" : ""
    }
  }

  const regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const valid = regex.test(trimmedValue);

  return { valid, errorKey: valid ? "" : "EnterAValidEmail" };
}

export function validateFullname(value) {
  const trimmedValue = (value || '').trim();

  if (!trimmedValue) {
    return { valid: false, errorKey: 'IndicateANameAndSurname' }
  }
  return { valid: true, errorKey: '' };
}

export function validatePhone(value, required) {
  const trimmedValue = (value || '').trim();
  const rawPhone = trimmedValue.replace(/\s+/g, '');

  if (!rawPhone || rawPhone.length < MIN_CHARS.PHONE) {
    return {
      valid: !required,
      errorKey: required ? "EnterAValidPhoneNumber" : ""
    };
  }

  const phoneRegex = /^\+?\d+$/;
  if (!phoneRegex.test(rawPhone)) {
    return {
      valid: false,
      errorKey: "EnterAValidPhoneNumber"
    };
  }

  return { valid: true, errorKey: '' };
}

export function validateComments(value, required) {
  const trimmedValue = (value || '').trim();
  
  if (!trimmedValue) {
    return {
      valid: !required,
      errorKey: required ? "ThisFieldIsRequired" : ""
    }
  }
  return { valid: true, errorKey: '' };
}

export function validateCustom(value, required) {
  const trimmedValue = (value || '').trim();
  
  if (!trimmedValue) {
    return {
      valid: !required,
      errorKey: required ? "ThisFieldIsRequired" : ""
    }
  }
  return { valid: true, errorKey: '' };
}